import { render, staticRenderFns } from "./agentWithdrawList.vue?vue&type=template&id=66959f96&scoped=true&lang=html"
import script from "./agentWithdrawList.vue?vue&type=script&lang=js"
export * from "./agentWithdrawList.vue?vue&type=script&lang=js"
import style0 from "./agentWithdrawList.vue?vue&type=style&index=0&id=66959f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66959f96",
  null
  
)

export default component.exports